import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ModuleProvider } from '@/base/contexts/ModuleContext';
import { ErrorBoundary } from '@/base/components/ErrorBoundary';
import App from './App';
import './styles/fonts.css';
import './styles/index.css';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

// Mount app
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ModuleProvider>
          <App />
        </ModuleProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
